import { StyleSheet, View } from 'react-native';
import { RadioButtonGroup, Text, theme } from '@socrait/react';

import { setupStore, REFERRAL_SOURCES } from '~/store/setupStore';

import { setupStepStyles } from './setupStepStyles';

export const ReferralSourceStep = () => {
  const { referralSource, setReferralSource } = setupStore();

  return (
    <View style={setupStepStyles.container}>
      <Text style={setupStepStyles.headerText}>
        Where did you hear about <Text style={setupStepStyles.headerTextPurple}>Socrait</Text>?
      </Text>
      <RadioButtonGroup
        containerStyle={styles.radioButtonGroupContainer}
        defaultIndex={REFERRAL_SOURCES.findIndex((option) => option.value === referralSource)}
        labelStyle={setupStepStyles.smallText}
        onSelectOption={(value) => setReferralSource(value as string)}
        options={REFERRAL_SOURCES}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  radioButtonGroupContainer: {
    paddingHorizontal: theme.spacing.xxlarge,
  },
});
